export const PRODUCT_NAME = 'flights'
